package org.example.site_web.content.page

val offersContent_Manifest1:String = "La mission d’Accelarge Innovations est de donner "+
"vie à vos idées et à vos projets\r\n en particulier sur les sujets d’amélioration des méthodes et des outils."

val offersContent_Part2:String = "Votre intuition d'opérationnel est fondamentale face aux problèmes existants et aux défis futurs."

val offersContent_Part3:String = "Mais concrétiser des améliorations techniques et des démarches innovantes\r\npeut être complexe pour de multiples raisons"

val offersContent_Part3List = listOf(
    "tensions et priorisations budgétaires",
    "difficultés de recrutement",
    "manque de compétences en internes",
    "maintenance onéreuse des solutions technologiques",
    "surcoût important des fonctionnalités sur-mesure")

val offersContent_Manifest2:String = "Face à ces difficultés, Accelarge Innovations apporte à vos projets\r\n efficacité, transparence et optimisme"

val offersContent_Part4:String = "Notre proposition de développement technique porte sur la réalisation de solutions combinant "

val offersContent_Part4List = listOf(
    "Informatique & Algorithmes",
    "Systèmes électroniques & Intégration",
    "Physique Appliquée")

val offersContent_Part4LC = listOf(
    listOf<String>("Interfaces hommes-machine et visualisation multi-support", "Gestion des données de acquisition-traitement-restitution "),
    listOf("Portage sur matériel spécifique de fonctionnalités", "Systèmes sur mesure", "Banc complexe avec intégration mécanique"),
    listOf<String>("Optique et Vision industrielle", "Mécanique, vibrations et hydraulique", "Mesure physique")
)

val offersContent_Part5:String = "Nous étudions votre idée, votre contexte et votre besoin de retour sur investissement pour délivrer la solution technique optimale."

val offersContent_Part5List: List<Pair<String, String>> = listOf<Pair<String,String>>(
"Moyens & Outils" to "Bancs et systèmes de contrôle et de validation\r\nOutils de diagnostic terrain\r\n"+
        "Outil de mesure et de saisie rapide\r\nFonctions d’automatisation",
"Optimisation" to "Utiliser à 100% les fonctionnalité des appareils\r\nExploiter les données\r\nFormation des collaborateurs "
        +"à de nouveaux outils\r\nInterface avec les systèmes de gestion",
"Anticipation" to "Étude de faisabilité\r\nDémonstrateur")